import {Link} from "react-router-dom";
import Breadcrumb from 'react-bootstrap/Breadcrumb'

const BreadcrumbsData = (props) => {

    let {links, home} = props;


    if (home) links = [{label: 'Strona główna', to: '/'}].concat(links);

    return <>
        <Breadcrumb className={'ms-2'}>
            {links.map((item, idx) => <Breadcrumb.Item linkProps={{to: item?.to}} linkAs={Link} key={idx}
                                                       active={idx === links?.length - 1}
                                                       href={item?.to || ''}>{item?.label}</Breadcrumb.Item>
            )}
        </Breadcrumb>
    </>

};

BreadcrumbsData.propTypes = {
    links: (props, propName, componentName) => {
        if (!Array.isArray(props[propName])) {
            return new Error(
                `Invalid prop \`${propName}\` supplied to \`${componentName}\`. Expected an array of objects with 'label' and optional 'to' properties.`
            )
        }
        for (let i = 0; i < props[propName].length; i++) {
            const item = props[propName][i]
            if (
                typeof item.label !== 'string' ||
                (item.to && typeof item.to !== 'string')
            ) {
                return new Error(
                    `Invalid prop \`${propName}\` supplied to \`${componentName}\`. Each object should have a 'label' (string) and an optional 'to' (string).`
                )
            }
        }
    },
    home: (props, propName, componentName) => {
        if (props[propName] && typeof props[propName] !== 'boolean') {
            return new Error(
                `Invalid prop \`${propName}\` supplied to \`${componentName}\`. Expected a boolean.`
            )
        }
    },
}

export default BreadcrumbsData;
